<div class="header-dependente">
  <div class="form-card">
    <form class="form">
      <app-input-select [children]="companies" [placeholder]="'Selecione a instituição'" [validators]="['required']" (isInputValid)="setFormStatus($event, 'dependentCompany')" [(value)]="dependentCompany"></app-input-select>
      <app-input [inputModel]="dependent.nomeInputModel" (isInputValid)="setFormStatus($event, 'name')" [(value)]="dependent.name"></app-input>

      <div>
        <app-input [inputModel]="dependent.nicknameInputModel" (isInputValid)="setFormStatus($event, 'nickname')" [(value)]="dependent.nickname"></app-input>
        <p class="mensagemCartao">* Cadastre um apelido para comprar nos terminais Meep, quando não estiver com o cartão Meep em mãos.</p>
      </div>
      <div *ngIf="dependentCompany && dependentCompany.isMeepCardAccepted && dependentCompany.requireNumberOnAssociate === 1">
        <app-input [inputModel]="dependent.cardNumberInputModel" (isInputValid)="setFormStatus($event, 'meepCardNumber')" [(value)]="dependent.cardNumber"></app-input>
        <p class="mensagemCartao">* Para realizar compras nos terminais Meep, faça o cadastro do seu cartão Meep informando o número.</p>
      </div>

      <div *ngIf="dependentCompany && dependentCompany.isMeepCardAccepted && dependentCompany.requireNumberOnAssociate === 2">
        <app-input [inputModel]="dependent.cardNumberInputModelNotRequired" [(value)]="dependent.cardNumber"></app-input>
        <p class="mensagemCartao">* Se você possuir o cartão Meep em mãos, faça o cadastro informando o seu número.</p>
      </div>

    </form>
    <button (click)="registerDependent()" class="confirma">
      Cadastrar
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/register-dependent/register-dependent.component.html